import { t } from '@lingui/macro';

export const emptyTextFieldErrorMessage = t`Requis`;

export const noSelectionValue = 'all';
export const noSelectionLabel = 'Tout';
